import { FC } from 'react';
import type { VirtualItem } from '@tanstack/react-virtual';
import type { DataTableColumn, DataTableDimensions } from '@/components/UI/DataTableV2/DataTable.model';
import { useDataTable } from '../DataTableProvider';
import { CellTypeRouter } from './CellTypeRouter';

interface StickyPinnedCellsProps {
  virtualRows: Array<VirtualItem>;
  pinnedDataColumns: Array<DataTableColumn>;
  rowHeaderWidth: number;
  dimensions: DataTableDimensions;
}

export const StickyPinnedCells: FC<StickyPinnedCellsProps> = ({
  virtualRows,
  pinnedDataColumns,
  rowHeaderWidth,
  dimensions,
}) => {
  const { dataTableService } = useDataTable();
  return (
    <>
      {virtualRows.map((virtualRow) => {
        return pinnedDataColumns.map((column, columnOffset) => {
          const columnIndex = dataTableService.toIndexColumn(column.id);
          if (columnIndex === undefined) {
            return null;
          }

          return (
            <CellTypeRouter
              key={`${virtualRow.key}_${column.id}`}
              coordinate={{ column: columnIndex, row: virtualRow.index }}
              positionOffset={{
                x: rowHeaderWidth + columnOffset * dimensions.cellWidth,
                y: virtualRow.start,
              }}
            />
          );
        });
      })}
    </>
  );
};
